import { GenerateFailureReason } from 'utils/analyticsPageExport/generate';
import { PreflightFailureReason } from 'utils/analyticsPageExport/preflight';

export const COOLDOWN_MS = 3000;
export const DEFAULT_THROTTLE_SECONDS = 60;

export const throttleMessage = (seconds: number): string =>
  `You've reached the export limit. Try again in ${seconds} ${
    seconds === 1 ? 'second' : 'seconds'
  }.`;

export const GENERATE_ERROR_MESSAGES: Record<
  Exclude<GenerateFailureReason, 'throttled'>,
  string
> = {
  file_size_exceeded:
    'Export exceeds the size limit. Narrow your filters or date range and try again.',
  page_limit_exceeded:
    'Export exceeds the page limit. Narrow your filters or date range and try again.',
  upstream_analytics_failed: 'Export failed. Please try again.',
  permission_denied: "You don't have permission to export this data.",
  png_invalid: 'Export failed while preparing the charts. Please try again.',
  timeout: 'Export timed out. Narrow your filters or date range and try again.',
  no_data: 'No data to export. Adjust your filters and try again.',
  request_failed: 'Invalid export request. Please refresh and try again.',
  unexpected_response_shape: 'Export failed unexpectedly. Please try again.',
};

export const PREFLIGHT_ERROR_MESSAGES: Record<
  Exclude<PreflightFailureReason, 'throttled'>,
  string
> = {
  permission_denied: "You don't have permission to export this data.",
  request_failed: 'Invalid export request. Please refresh and try again.',
  upstream_analytics_failed: 'Export failed. Please try again.',
  unexpected_response_shape: 'Export failed unexpectedly. Please try again.',
  timeout: 'Preflight timed out. Narrow your filters or date range and try again.',
  no_data: 'No data to export. Adjust your filters and try again.',
};
